/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="78.36"
        height="88.92"
        viewBox="0 0 78.36 88.92"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M12.69 1c-2.33 1.51-4.57 3-6.76 4.65a14.54 14.54 0 0 0-5.75 14C5.06 50.92 24.9 75.93 54.29 87.86a14.61 14.61 0 0 0 15-2.38c2.07-1.76 4.09-3.58 6.09-5.49a6.14 6.14 0 0 0 .28-8.59L64.84 59.64a7.14 7.14 0 0 0-10.3-.24l-4.45 4.43-.22.19-.21.16a2.53 2.53 0 0 1-3.32 0 107.44 107.44 0 0 1-24.9-31.35 2.54 2.54 0 0 1 .61-3.13l.22-.17a3.13 3.13 0 0 1 .35-.26L28 25.91a7.1 7.1 0 0 0 2.27-9.84l-1.59-2.35-7.53-11A6.17 6.17 0 0 0 12.92.89Zm6.36 3.11 9 13.16a4.62 4.62 0 0 1-1.39 6.53l-5.35 3.3-.23.15-.22.16-.17.14A5 5 0 0 0 19.23 34a109.72 109.72 0 0 0 25.48 32l.19.15a5 5 0 0 0 6.21 0l.16-.13h-.06a4.92 4.92 0 0 0 .64-.54l4.46-4.43a4.65 4.65 0 0 1 6.69.16l10.78 11.74a3.64 3.64 0 0 1-.16 5.09c-2 1.87-4 3.67-6 5.39a12.09 12.09 0 0 1-12.4 2C26.66 73.93 7.4 49.65 2.65 19.24A12 12 0 0 1 7.41 7.66c2.15-1.57 4.35-3.09 6.64-4.57a3.65 3.65 0 0 1 5 1.01Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M57.14 40a12.12 12.12 0 0 0-9.94-12.2 1.25 1.25 0 1 1 .41-2.46 14.58 14.58 0 0 1 12 14.71v.33a1.25 1.25 0 0 1-2.5 0Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M46.79 17.29a1.25 1.25 0 0 1 1.44-1A24.84 24.84 0 0 1 68.64 41.6V42.48a1.24 1.24 0 0 1-1 .64h-.13A1.24 1.24 0 0 1 66.13 42v-.57a22.36 22.36 0 0 0-18-22.63l-.34-.06a1.25 1.25 0 0 1-1-1.45Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M78.28 43.57a1.251 1.251 0 0 1-2.5-.1v-.13C76.9 27 64.65 11.62 48.49 9a1.252 1.252 0 1 1 .41-2.47c17.25 2.84 30.32 19.09 29.41 36.52Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'TelephoneWithOutgoingSoundIcon';

export default Icon;
